/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Home_DescriptionInputs */

const en_meta_home_description = /** @type {(inputs: Meta_Home_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom AI agents, agent teams, research agents and complete AI systems for small businesses and growing companies. Built in Latvia, in your tools, inside limits you agree.`)
};

const lv_meta_home_description = /** @type {(inputs: Meta_Home_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI aģenti, aģentu komandas, izpētes aģenti un pilnas AI sistēmas maziem un augošiem uzņēmumiem. Izstrādāts Latvijā, Jūsu rīkos, Jūsu noteiktās robežās.`)
};

/**
* | output |
* | --- |
* | "Custom AI agents, agent teams, research agents and complete AI systems for small businesses and growing companies. Built in Latvia, in your tools, inside lim..." |
*
* @param {Meta_Home_DescriptionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const meta_home_description = /** @type {((inputs?: Meta_Home_DescriptionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Home_DescriptionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_meta_home_description(inputs)
	return en_meta_home_description(inputs)
});